import { useCallback, useEffect, useMemo, useState } from 'react'

// Contract
import FTM from 'contracts/FTM.json'
import fUSDC from 'contracts/fUSDT.json'

// Hooks
import { useERC20 } from 'hooks/useERC20/useERC20'
import { useWalletContext } from 'providers/WalletProvider'

// Types
import { UseSpendableTokenReturnType } from './useSpendableToken.types'

// Constants
import {
  TESTNET_USDC_ADDRESS,
  TESTNET_USDC_DECIMALS,
  TESTNET_USDC_SUFIX,
  USDC_ADDRESS,
  USDC_DECIMALS,
  USDC_SUFIX,
  WPOKT_ADDRESS,
  WPOKT,
  SafePOKT_POKT_ADDRESS,
} from './useSpendableToken.constants'

// Utils
import { refreshTwice } from 'utils/refreshTwice'

export const useSpendableToken = (): UseSpendableTokenReturnType => {
  const state = useWalletContext()

  const [isLoadingUSDC, setIsLoadingUSDC] = useState(true)
  const [balanceUSDC, setBalanceUSDC] = useState(0)

  const [isLoadingWpoktEth, setIsLoadingWpoktEth] = useState(true)
  const [balanceWpoktEth, setBalanceWPoktEth] = useState(0)

  const [abi, address, decimals, sufix] = useMemo(() => {
    return state.isTestNetwork
      ? [FTM, TESTNET_USDC_ADDRESS, TESTNET_USDC_DECIMALS, TESTNET_USDC_SUFIX]
      : [fUSDC, USDC_ADDRESS, USDC_DECIMALS, USDC_SUFIX]
  }, [state.isTestNetwork])

  const interactionsUSDC = useERC20(state, abi, address, decimals)

  const initializeParamsUSDC = useCallback(async () => {
    if (state.currentAccount) {
      try {
        const balance = (await interactionsUSDC.balanceOf(
          state.currentAccount
        )) as number
          
        setBalanceUSDC(balance)
        setIsLoadingUSDC(false)
      } catch (e) {
        if ( !(e as any).message || !(e as any).message.includes("underlying network changed") ) console.log(e)
      }
    }
  }, [interactionsUSDC, state.currentAccount])

  const interactionsWpoktEth = useERC20(state, WPOKT, WPOKT_ADDRESS, decimals, "ethereum")

  const initializeParamsWpoktEth = useCallback(async () => {
    if (state.currentAccount) {
      try {
        const balance = (await interactionsWpoktEth.balanceOf(
          state.currentAccount
        )) as number
 
        setBalanceWPoktEth(balance)
        setIsLoadingWpoktEth(false)
      } catch (e) { 
        if ( !(e as any).message || !(e as any).message.includes("underlying network changed") ) console.log(e)
      }
    }
  }, [interactionsWpoktEth, state.currentAccount])


  // const initializeEvents = useCallback(
  //   (currentAccount: string) => {
  //     interactions.setEvent(
  //       'Transfer',
  //       (from: string, to: string, value: number) => {
  //         setBalance(
  //           (currentBalance) => currentBalance - toNormalNumber(value, decimals)
  //         )
  //       },
  //       [currentAccount]
  //     )

  //     interactions.setEvent(
  //       'Transfer',
  //       (from: string, to: string, value: number) => {
  //         setBalance(
  //           (currentBalance) => currentBalance + toNormalNumber(value, decimals)
  //         )
  //       },
  //       [null, currentAccount]
  //     )
  //   },
  //   [interactions, setBalance, decimals]
  // )

  useEffect(() => {
    initializeParamsUSDC()
  }, [initializeParamsUSDC])

  useEffect(() => {
    initializeParamsWpoktEth()
  }, [initializeParamsWpoktEth])

  const refreshParamsUSDC = useCallback(() => {
    refreshTwice(initializeParamsUSDC)
  }, [initializeParamsUSDC])

  const refreshParamsWpoktEth = useCallback(() => {
    refreshTwice(initializeParamsWpoktEth)
  }, [initializeParamsWpoktEth])

  // useEffect(() => {
  //   if (state.currentAccount) {
  //     initializeEvents(state.currentAccount)
  //   }

  //   return () => {
  //     if (state.currentAccount) {
  //       interactions.cleanEvents()
  //     }
  //   }
  // }, [initializeEvents, interactions.cleanEvents, state.currentAccount])

    const WpoktAddress = WPOKT_ADDRESS;
    const BuyWPOKTDestination = SafePOKT_POKT_ADDRESS;

  return {
    interactionsUSDC,
    interactionsWpoktEth,
    refreshParamsUSDC,
    refreshParamsWpoktEth,
    address,
    sufix,
    isLoadingUSDC,
    isLoadingWpoktEth,
    balanceUSDC,
    balanceWpoktEth,
    WpoktAddress,
    BuyWPOKTDestination,
  }
}
